/* PDP media delivery only. First images and the first four thumbnails stay native. */
(() => {
  if (window.evoObserveDeferredMedia) {
    window.evoObserveDeferredMedia(document);
    return;
  }
  const selector = '[data-evo-deferred-image], [data-evo-deferred-background]';
  const observed = new WeakSet();
  const imageObservers = new WeakMap();
  const railObservers = new Map();
  let observer;

  const load = (node) => {
    if (!node || node.dataset.evoMediaLoaded === 'true') return;
    const image = node.dataset.evoImageSrc;
    const background = node.dataset.evoDeferredBackground;
    if (!image && !background) return;
    node.dataset.evoMediaLoaded = 'true';
    if (image) {
      if (node.dataset.evoImageSrcset) node.srcset = node.dataset.evoImageSrcset;
      node.src = image;
    }
    if (background) node.style.setProperty('--evo-demo-image', `url(${JSON.stringify(background)})`);
    imageObservers.get(node)?.unobserve(node);
  };
  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => { if (entry.isIntersecting) load(entry.target); });
    }, { rootMargin: '200px', threshold: 0.01 });
  }
  const observe = (node) => {
    if (observed.has(node)) return;
    observed.add(node);
    if (observer) {
      // The rail clips its children. Give upcoming thumbnails a real preload
      // margin inside that scrolling container, before a swipe reveals them.
      const rail = node.closest('.swiper-controls__thumbnails-container .swiper');
      let targetObserver = observer;
      if (rail) {
        if (!railObservers.has(rail)) {
          railObservers.set(rail, new IntersectionObserver((entries) => {
            entries.forEach((entry) => { if (entry.isIntersecting) load(entry.target); });
          }, { root: rail, rootMargin: '200px', threshold: 0.01 }));
        }
        targetObserver = railObservers.get(rail);
      }
      imageObservers.set(node, targetObserver);
      targetObserver.observe(node);
    }
    else load(node);
  };
  const scan = (root) => {
    if (root.matches?.(selector)) observe(root);
    root.querySelectorAll?.(selector).forEach(observe);
  };
  window.evoObserveDeferredMedia = scan;
  scan(document);
  // Variant/section replacement inserts new media; inspect only added subtrees.
  // Quick-view modals sit outside MainContent, which can itself be replaced.
  if (document.body) {
    new MutationObserver((records) => {
      records.forEach((record) => record.addedNodes.forEach((node) => {
        if (node.nodeType === 1) scan(node);
      }));
      railObservers.forEach((railObserver, rail) => {
        if (!rail.isConnected) {
          railObserver.disconnect();
          railObservers.delete(rail);
        }
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  const onIntent = (event) => {
    const target = event.target.closest?.('.swiper-controls__thumbnail, [data-evo-deferred-image], [data-evo-deferred-background]');
    if (!target) return;
    if (target.matches(selector)) load(target);
    target.querySelectorAll(selector).forEach(load);
  };
  document.addEventListener('pointerdown', onIntent, { passive: true });
  document.addEventListener('focusin', onIntent);
})();
